import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const southHillsboroConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'South Hillsborough Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal across South Hillsborough County, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_south_hillsborough',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving South Hillsborough',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service Across South Hillsborough Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we cover the full stretch of 
     <strong>South Hillsborough County</strong> from the waterfront communities 
     along Tampa Bay to the rural properties deep in the county's interior. This 
     diverse region presents every type of tree challenge Florida has to offer: 
     coastal storm exposure, riverfront flooding, rural acreage overgrowth, and 
     dense suburban canopies pressing against homes and structures. Our team 
     handles all of it.`,

    `We specialize in <strong>the full range of hazardous and dangerous tree 
     situations</strong> waterfront and flood zone tree removal, large rural 
     takedowns, precision trimming in tight residential subdivisions, storm 
     response and debris cleanup, and canopy management that reduces risk 
     before hurricane season. No job in South Hillsborough is outside 
     our service area.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable, and expert 
     tree care throughout <strong>South Hillsborough County</strong> and into the 
     surrounding <strong>Tampa Bay region</strong> keeping every property 
     we service safe, clean, and protected all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'South Hillsborough County, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SouthHillsboro = () => <LocationPage config={southHillsboroConfig} />;
export default Services_SouthHillsboro;
